import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const axios = require('axios').default;

export default new Vuex.Store({
  state: {
    user: '',
    token: localStorage.getItem('user-token') || '',
    userId: localStorage.getItem('user-id') || '',
    snackbar: {
      isActive: false,
      text: '',
    },
  },

  getters: {
    isAuth: (state) => !!state.token,
  },

  mutations: {
    SET_AUTH(state, data) {
      state.token = data.token;
      state.userId = data.id;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_SNACKBAR(state, data) {
      state.snackbar.isActive = data.isActive;
      state.snackbar.text = data.text;
    },
  },

  actions: {
    // eslint-disable-next-line arrow-body-style
    authenticate: ({ commit, dispatch }, credentials) => {
      return new Promise((resolve, reject) => {
        axios.post('signin', credentials)
          .then((res) => {
            const token = res.data.tokens.access;
            const id = res.data.candidat_id;
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            localStorage.setItem('user-token', token);
            localStorage.setItem('user-id', id);
            commit('SET_AUTH', { token, id });
            resolve(res);
          })
          .catch((error) => {
            dispatch('logOut');
            reject(error);
          });
      });
    },
    // eslint-disable-next-line arrow-body-style
    getUserData: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        axios.get(`candidats/${state.userId}`)
          .then((res) => {
            const data = { ...res.data };
            const user = {
              id: data.id,
              firstName: data.prenom,
              lastName: data.nom,
              password: data.password_digest,
              gender: data.genre,
              birthDate: data.date_naissance,
              nationality: data.nationalite,
              email: data.email,
              mobile: data.tel,
              address: {
                streetAndNumber: data.adresse,
                zipCode: data.code_postal,
                city: data.ville,
                country: data.pays,
              },
              applications: data.postulations,
            };
            commit('SET_USER', user);
            resolve(res);
          })
          .catch((error) => {
            dispatch('logOut');
            reject(error);
          });
      });
    },
    logOut: ({ commit }) => {
      delete axios.defaults.headers.common.Authorization;
      localStorage.removeItem('user-token');
      localStorage.removeItem('user-id');
      commit('SET_AUTH', { token: '', id: '' });
      commit('SET_USER', '');
    },
    // eslint-disable-next-line arrow-body-style
    updateUserData: ({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        axios.put(`candidats/${state.userId}`, data)
          .then((res) => {
            const newData = { ...res.data };
            const user = {
              id: newData.id,
              firstName: newData.prenom,
              lastName: newData.nom,
              password: newData.password_digest,
              gender: newData.genre,
              birthDate: newData.date_naissance,
              nationality: newData.nationalite,
              email: newData.email,
              mobile: newData.tel,
              address: {
                streetAndNumber: newData.adresse,
                zipCode: newData.code_postal,
                city: newData.ville,
                country: newData.pays,
              },
            };
            commit('SET_USER', user);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  modules: {
  },
});
